import kayaanLogo from "/images/kayaan-logo.jpeg";
import kayaanLogoSmall from "/images/kayaan-logo-small.jpeg";

type ImageProps = React.DetailedHTMLProps<
  React.ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
>;

export const TeziLogoWithTextTP: React.FC<ImageProps> = (props) => {
  return (
    <img 
      src={kayaanLogo}
      alt="Kayaan Logo"
      className="w-400 h-auto"
      width={138}
      height={50}
      {...props}
    />
  );
};

export const TeziLogo: React.FC<ImageProps> = (props) => {
  return (
    <img
      src={kayaanLogo}
      alt="Kayaan Logo"
      className="w-400 h-auto"
      width={28}
      height={28}
      {...props}
    />
  );
};

export const TeziLogoTP: React.FC<ImageProps> = (props) => {
    return (
      <img
        src={kayaanLogoSmall}
        alt="Kayaan Logo"
        className="w-400 h-auto"
        width={40}
        height={40}
        {...props}
      />
    );
  };